import { observer } from 'mobx-react-lite';
import { FC, useEffect, useState } from 'react';
import { Property } from '@codefluegel/wowis-rest-typescript-client';
import { autorun } from 'mobx';

import { Box } from '@mui/material';
import { useMonitorApi } from '../../ApiClient';
import useMedia from '../../hooks/useMedia';
import { useStore } from '../../store/context';

interface Props {
  currentEstate: Property;
  isMainDashboard: boolean;
}

const DashMonitor: FC<Props> = observer(props => {
  const { currentEstate, isMainDashboard } = props;
  const monitorApi = useMonitorApi();

  const isMobile = useMedia('md');

  const [monitorAvailable, setMonitorAvailabel] = useState(false);
  const { userStore } = useStore();

  if (!currentEstate?.customerId) {
    return <div>Keine Kundennummer vorhanden</div>;
  }

  useEffect(
    () =>
      autorun(() => {
        async function getMonitor() {
          try {
            const monitor = await monitorApi.getMonitor(
              Number(currentEstate.objId) || 0,
              1,
            );

            if (monitor.data) {
              setMonitorAvailabel(true);
              userStore.setHasBlackboard(true);
            }
          } catch (error) {
            console.log({ error });
          }
        }
        if (
          !monitorAvailable &&
          currentEstate?.objId &&
          currentEstate?.customerId
        )
          getMonitor();
      }),
    [monitorAvailable, monitorApi],
  );

  if (!monitorAvailable || (isMobile && isMainDashboard)) return null;
  return (
    <Box width={1} height="75vh" sx={{ display: 'flex', alignItems: 'center' }}>
      <iframe
        style={{
          transform: isMobile && !isMainDashboard ? 'rotate(90deg)' : '',
        }}
        width="99.5%"
        height={isMobile ? '60%' : '100%'}
        title="monitor"
        frameBorder={0}
        src={`https://monitor.wohnbaugruppe.at/info/Monitore/${currentEstate.objId}/0`}
      />
    </Box>
  );
});

export default DashMonitor;
